/**
 * Public company / contact constants. Single source of truth for anything
 * customer-facing that names the business or tells people where to write.
 */

/** Public support inbox shown in the dashboard, worker error messages and emails. */
export const SUPPORT_EMAIL = 'support@dealcloserautopilot.com'

/** Legal entity that operates DealCloser Autopilot. */
export const COMPANY_LEGAL_NAME = 'Elevated Talent, LLC'

/** Resend-verified sender address for product / lifecycle / operator emails. */
export const UPDATES_FROM_EMAIL = 'updates@dealcloserautopilot.com'

/**
 * Where staff alerts go (digest, "human needed", support tickets) when the
 * worker's STAFF_ALERT_TO var is unset. Company inboxes only: these emails
 * carry customer data, so no personal addresses (launch audit 2026-10-24).
 */
export const DEFAULT_STAFF_ALERT_TO: readonly string[] = [SUPPORT_EMAIL, 'eli@jahvis.ai']

/** STAFF_ALERT_TO (comma-separated) as a list, else DEFAULT_STAFF_ALERT_TO. */
export function staffAlertRecipients(raw: string | undefined | null): string[] {
  const list = (raw ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter((s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s))
  return list.length > 0 ? list : [...DEFAULT_STAFF_ALERT_TO]
}
